module.exports = __webpack_public_path__ + "images/hockey1-4bf932caeaa7f1e8e91d7d1905f65938.jpg";